export const DEFAULT_SHIPPING_METHOD_NAME = 'Most Economical';
